import React, { Component } from "react";
import Select from "react-select";

import config from "../mp-config"
import logo from "../../assets/img/img_logo.png";
import startIcon from "../../assets/img/ic_pin_gris.png";
import endIcon from "../../assets/img/ic_ubicacion.png";
import dottedLine from "../../assets/img/img_linea_gris.png";
import dottedLineDesktop from "../../assets/img/img_linea_gris_desktop.png";

import banoImg from "../../assets/img/services/ic_bano.png";
import cajeroImg from "../../assets/img/services/ic_cajero.png";
import directorioImg from "../../assets/img/services/ic_directorio.png";
import informacionImg from "../../assets/img/services/ic_informacion.png";
import lactanciaImg from "../../assets/img/services/ic_lactancia.png";
import ascensorImg from "../../assets/img/services/ic_ascensor.png";
import estacionamientoImg from "../../assets/img/services/ic_estacionamiento.png";
import casinoImg from "../../assets/img/services/ic_casino.png";
import cafeteriaImg from "../../assets/img/services/ic_cafeteria.png";

import banoImgSelected from "../../assets/img/services/ic_bano_seleccionado.png";
import cajeroImgSelected from "../../assets/img/services/ic_cajero_seleccionado.png";
import directorioImgSelected from "../../assets/img/services/ic_directorio_seleccionado.png";
import informacionImgSelected from "../../assets/img/services/ic_informacion_seleccionado.png";
import lactanciaImgSelected from "../../assets/img/services/ic_lactancia_seleccionado.png";
import ascensorImgSelected from "../../assets/img/services/ic_ascensor_seleccionado.png";
import estacionamientoImgSelected from "../../assets/img/services/ic_estacionamiento_seleccionado.png";
import casinoImgSelected from "../../assets/img/services/ic_casino_seleccionado.png";
import cafeteriaImgSelected from "../../assets/img/services/ic_cafeteria_seleccionado.png";

import SelectorWidgetDesktop from "./start/SelectorWidgetDesktop"
import SelectorWidgetMobile from "./start/SelectorWidgetMobile"
import { formatDisplayName } from "../utils/nameFormat"

let TAGS_SEP = "//[TAGS]//"
let pm1, p0, p1, p2, p3, p4;

// Modo tótem: cuando está activo (parámetro ?kiosk=1 en la URL, usado en las
// pantallas fijas de los tótems de entrada), el origen queda restringido a
// los lugares cuyo nombre contiene "entrada" (los 2 tótems: Entrada
// Tecnoaulas y Entrada Torre 26). El tótem físico de cada entrada apunta a
// su propia URL con ?kiosk=1&from=<id>, fijando así su punto de partida.
const KIOSK_MODE = new URLSearchParams(window.location.search).get("kiosk") === "1";
const ENTRANCE_MATCH = /entrada/i;

class StartView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      start: this.props.start,
      end: this.props.end,
      errorMessage: false,
      stores: this.props.stores || false,
      bathroom: banoImg,
      redbanc: cajeroImg,
      dd: directorioImg,
      info: informacionImg,
      milk: lactanciaImg,
      elevator: ascensorImg,
      parking: estacionamientoImg,
      casino: casinoImg,
      cafeteria: cafeteriaImg
    };
    this.renderStoresSelector = this.renderStoresSelector.bind(this);
    this.onStoreSet = this.onStoreSet.bind(this);
    pm1 = this.props.pm1;
    p0 = this.props.p0;
    p1 = this.props.p1;
    p2 = this.props.p2;
    p3 = this.props.p3;
    p4 = this.props.p4;
  }

  onStoreSet(selected, settingStart, service) {
    if (settingStart) {
      if (selected) {
        let value = selected.value.split(TAGS_SEP)[0]
        let selectedNode = this.auxGetAllNodes().filter(
          n => n.store_info.id === value
        )[0];

        this.setState({ start: selectedNode });
      } else this.setState({ start: false });
      //if (selected && !startNode) alert("Tienda no encontrada");
    } else {
      if (service) {
        this.paintSelectedService(service)
        this.setState({
          end: {
            service: true,
            type: service,
            name: this.getServiceName(service)
          }
        });
        return;
      }
      if (selected) {
        this.paintSelectedService()
        let value = selected.value.split(TAGS_SEP)[0]
        let selectedNode = this.auxGetAllNodes().filter(
          n => n.store_info.id === value
        )[0];
        this.setState({ end: selectedNode });
      } else this.setState({ end: false });
      //if (selected && !endNode) alert("Tienda no encontrada");
    }
  }

  componentDidMount() {
    const queryParams = new URLSearchParams(window.location.search);
    const startId = queryParams.get("from");
    const endId = queryParams.get("to");
    let { start, end } = this.state;

    if (startId) {
      const startNode = this.auxGetAllNodes().find((node) => node.store_info.id === startId);
      if (startNode && (!KIOSK_MODE || ENTRANCE_MATCH.test(startNode.store_info.title))) {
        start = startNode;
      }
    }
    if (endId) {
      const endNode = this.auxGetAllNodes().find((node) => node.store_info.id === endId);
      if (endNode) end = endNode;
    }

    if (start !== this.state.start || end !== this.state.end) {
      this.setState({ start, end }, () => {
        if (start && end) this.didSelectionFinished();
      });
    }
  }

  paintSelectedService(service){
    this.setState({
      bathroom: service === 'bathroom' ? banoImgSelected : banoImg,
      redbanc: service === 'redbanc' ? cajeroImgSelected : cajeroImg,
      dd: service === 'dd' ? directorioImgSelected : directorioImg,
      info: service === 'info' ? informacionImgSelected : informacionImg,
      milk: service === 'milk' ? lactanciaImgSelected : lactanciaImg,
      elevator: service === 'elevator' ? ascensorImgSelected : ascensorImg,
      parking: service === 'parking' ? estacionamientoImgSelected : estacionamientoImg,
      casino: service === 'casino' ? casinoImgSelected : casinoImg,
      cafeteria: service === 'cafeteria' ? cafeteriaImgSelected : cafeteriaImg
    })
  }

  didSelectionFinished() {
    //ga('send', 'event', 'mapa', 'ruta', 'flecha');
    let { start, end } = this.state;
    if (start && end) {
      if (start.id === end.id) {
        this.setState({
          errorMessage:
            "La tienda de origen no puede ser la misma tienda de destino"
        });
        return;
      }
      this.props.onSelectionFinished(start, end);
      this.setState({ errorMessage: false });
    } else
      this.setState({
        errorMessage: "Debes elegir una tienda de origen y tienda o servicio de destino"
      });
  }

  auxGetAllNodes() {
    return p1
      .filter(n => n.store)
      .concat(p2.filter(n => n.store))
      .concat(p3.filter(n => n.store))
      .concat(p0.filter(n => n.store))
      .concat(p4.filter(n => n.store))
      .concat(pm1.filter(n => n.store));
  }

  auxGettAllStores() {
    return p1
      .filter(n => n.store)
      .concat(p2.filter(n => n.store))
      .concat(p3.filter(n => n.store))
      .concat(p0.filter(n => n.store))
      .concat(p4.filter(n => n.store))
      .concat(pm1.filter(n => n.store))
      .sort((a,b) => (a.store_info.title > b.store_info.title) ? 1 : -1);
  }

  getServiceName(service){
    let names = this.props.config.serviceNames;
    if (names && names[service]) return names[service];
    switch(service){
      case 'bathroom':
        return "Baños";
      case 'redbanc':
        return "Cajero";
      case 'dd':
        return "Directorio Digital";
      case 'info':
        return "Núcleo de informaciones"
      case 'milk':
        return "Sala Lactancia";
      case 'elevator':
        return "Ascensores";
      case 'parking':
        return "Acceso estacionamientos";
      case 'casino':
        return "Casino";
      case 'cafeteria':
        return "Cafetería";
      default:
        return service;
    }
  }

  decodeHTMLEntities(text) {
    const textArea = document.createElement('textarea');
    textArea.innerHTML = text;
    return formatDisplayName(textArea.value);
  }

  renderStoresSelector(settingStart) {
    let { start, end } = this.state;
    let { stores } = this.props;
    let auxStores = this.auxGettAllStores();
    if (settingStart && KIOSK_MODE) {
      auxStores = auxStores.filter(s => ENTRANCE_MATCH.test(s.store_info.title));
    }
    let options = auxStores.map(s => {
      let newStores = []
      if (stores) {
        newStores = [...stores.fm1, ...stores.f0, ...stores.f1, ...stores.f2, ...stores.f3];
      }
      return {
        // Nombre desde WordPress; si el lugar no está allá (p.ej. Aula Magna),
        // el del nodo de ruta.
        label: this.decodeHTMLEntities((newStores.find(i => s.store_info.id.toString() === i.id) || {}).title || s.store_info.title),
        value: s.store_info.id,
        multiFloor: s.multi_floor
      };
    });
    if(stores && !settingStart){
      let allStores = [...stores.fm1, ...stores.f1, ...stores.f2, ...stores.f3, ...stores.f0];
      options = options.filter(o => {
        // Coincidencia exacta de id: con includes() "8529" también calzaba con "85".
        let auxStore = allStores.filter(s => (o.value + "") === s.id)
        if(!settingStart && o.multiFloor)
          return false;
        if(auxStore[0]) {
          o.label = `${this.decodeHTMLEntities(auxStore[0].title)}`
          o.value = o.value + TAGS_SEP + auxStore[0].tags
        }
        return true;
      })
    }
    let multiFloorStores = auxStores.filter(o => o.multi_floor);
    if(!settingStart && start){
      let auxMultiFloorStores = multiFloorStores.filter(o => o.store_info.nivel === start.store_info.nivel);
      if(auxMultiFloorStores[0]) // Existían en el piso
        multiFloorStores = auxMultiFloorStores
      multiFloorStores.forEach(s => {
        options.push({ label: this.decodeHTMLEntities(s.store_info.title), value: s.store_info.id })
      })
    }
    let node = settingStart ? start : end;
    let placeholder = settingStart ? "¿Dónde estás?" : "¿Dónde quieres ir o qué necesitas?";
    let selectedValue;
    if (node && node.store_info) selectedValue = { value: node.id, label: this.decodeHTMLEntities(node.store_info.title) };
    if (node && node.service) selectedValue = { value: node.service, label: this.getServiceName(node.type) };
    return (
      <Select
        className="form-control-light"
        searchable={true}
        name="form-field-name"
        placeholder={placeholder}
        value={selectedValue}
        onChange={selected => this.onStoreSet(selected, settingStart)}
        options={options.map(o => {return {label: o.label, value: o.value}})}
        optionRenderer={o => this.renderOptions(o)}
      />
    );
  }

  renderOptions(option) {
    return (
      <div key={option.value}>{option.label}
        {/*&nbsp;<div style={{fontSize: 10 + "px"}}>{tagsDescription}</div>*/}
      </div>);
  }

  render() {
    let { errorMessage } = this.state;
    return (
      <div className="mobile-fit" id="startview">
        <div className="d-md-none background" />
        <div className="d-none d-md-block background-md" />
        <div style={{ zIndex: 10 }} className="header-form mt-2">
          {/*<img alt="" src={logo} className="logo" />*/}
          <div className="info text-center">
            Permítenos ayudarte a llegar<br />
            más rápido a tu destino
          </div>
          <div className="d-md-none">
            <SelectorWidgetMobile
              dottedLine={dottedLineDesktop}
              endIcon={endIcon}
              startIcon={startIcon}
              renderStoresSelector={this.renderStoresSelector}
              onStoreSet={this.onStoreSet}
              errorMessage={errorMessage}
              bathroom={this.state.bathroom}
              redbanc={this.state.redbanc}
              dd={this.state.dd}
              info={this.state.info}
              milk={this.state.milk}
              elevator={this.state.elevator}
              parking={this.state.parking}
              casino={this.state.casino}
              cafeteria={this.state.cafeteria}
              config={this.props.config}
              />
          </div>
          <div className="d-none d-md-block">
            <SelectorWidgetDesktop
              endIcon={endIcon}
              dottedLineDesktop={dottedLineDesktop}
              startIcon={startIcon}
              renderStoresSelector={this.renderStoresSelector}
              onStoreSet={this.onStoreSet}
              errorMessage={errorMessage}
              bathroom={this.state.bathroom}
              redbanc={this.state.redbanc}
              dd={this.state.dd}
              info={this.state.info}
              milk={this.state.milk}
              elevator={this.state.elevator}
              parking={this.state.parking}
              casino={this.state.casino}
              cafeteria={this.state.cafeteria}
              config={this.props.config}
            />
          </div>
        </div>
        <div className="d-md-none fab"
          onClick={() => this.didSelectionFinished()}>
          <span className="fab-action-button">
            <i className="fab-action-button__icon" />
          </span>
        </div>
        <div className="d-none d-md-block">
          <div className="fab-desktop-container">
            <div className="fab-desktop"
              onClick={() => this.didSelectionFinished()}>
              <span className="fab-action-button fab-action-button-desktop">
                <i className="fab-action-button__icon" />
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default StartView;



// WEBPACK FOOTER //
// ./src/views/StartView.js